import { withMeetingBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/meetingBased';

import type { SportsAnimalRacingLandingPageState } from './types';

export const defaultState =
  withMeetingBasedMarketTemplateModelState<SportsAnimalRacingLandingPageState>({
    isLoading: false,
    hasPreloaded: false,
    eventTypes: {},
    meetings: {},
    races: {},
    markets: {},
    popularAccumulators: []
  });
